import styled from "styled-components";
import { BREAKPOINT_MAX } from "../../styles/responsiveBreakpoints";

export const Container = styled.div`
  width: 100%;
  min-width: 0;
  min-height: 100vh;
  background-color: ${({ theme }) => theme.tokens.color.background.secondary};
  font-family: 'LATAM Sans Regular', 'LATAM Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;
  box-sizing: border-box;
`;

export const Header = styled.div<{ $hasManualReviewBanner?: boolean }>`
  background: transparent;
  padding-bottom: 1.5rem;

  @media (min-width: ${BREAKPOINT_MAX.md + 1}px) {
    padding-bottom: ${({ $hasManualReviewBanner }) =>
      $hasManualReviewBanner ? '0' : '1.5rem'};
  }
`;

export const SectionTitleText = styled.div`
  margin-bottom: 1.5rem;
  
  &:first-child {
    margin-top: 0;
  }
`;

export const Content = styled.main`
  padding: 0;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;
`;

export const ItineraryCard = styled.div`
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  background: #ffffff;
  border-radius: 0.5rem;
  padding: 1.5rem;
  margin-bottom: 1.5rem;

  @media (max-width: ${BREAKPOINT_MAX.md}px) {
    padding: 1rem;
  }
`;

export const SkeletonBackLink = styled.div`
  margin-bottom: 1.25rem;
`;

export const SkeletonBackButton = styled.button`
  cursor: pointer;
  border: none;
  background: none;
  font-family: 'LATAM Sans Regular', 'LATAM Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;
  font-size: 1rem;
  font-weight: bold;
  color: ${({ theme }) => theme.tokens?.color?.interaction?.softDefault ?? '#0D12AB'};
  padding: 0;
`;

export const SkeletonHeaderShadows = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-bottom: 1.5rem;
  & > * { width: 100%; max-width: 280px; height: 1.25rem; border-radius: 4px; }
`;

export const SkeletonHeaderCard = styled.div`
  background: #FFFFFF;
  border-radius: 0.5rem;
  padding: 1.25rem 1.5rem;
  margin-bottom: 1.5rem;
  display: flex;
  flex-direction: row;
  gap: 1.5rem;
  flex-wrap: wrap;
  & > * { flex: 1; min-width: 100px; height: 2rem; border-radius: 4px; }
`;

export const SkeletonCard = styled.div`
  width: 100%;
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;
  background: #FFFFFF;
  border-radius: 0.5rem;
  padding: 1.5rem;
  margin-bottom: 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;

export const SkeletonCardTitle = styled.div`
  margin-bottom: 0;
`;

/** Alineado con ItineraryColumns: evita overflow horizontal (flex items con min-width:0 y basis 0). */
export const SkeletonItineraryBlocks = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1.5rem;
  margin-top: 1.25rem;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;

  & > * {
    flex: 1 1 0;
    min-width: 0;
    max-width: 100%;
    min-height: 3.5rem;
    border-radius: 4px;
  }

  @media (max-width: ${BREAKPOINT_MAX.lg}px) {
    flex-direction: column;

    & > * {
      flex: 1 1 auto;
      width: 100%;
    }
  }
`;

export const SkeletonFormCard = styled.div`
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  background: ${({ theme }) => theme.tokens.color.surface.primary};
  border-radius: 0.5rem;
  padding: 1.5rem;
  margin-bottom: 1.5rem;
`;

export const SkeletonTwoCols = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2rem;
  margin-top: 0;

  @media (max-width: ${BREAKPOINT_MAX.lg}px) {
    grid-template-columns: 1fr;
  }
`;

export const SkeletonCol = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  min-width: 0;
`;

export const SkeletonBlock = styled.div<{ $wide?: boolean; $tall?: boolean }>`
  width: 100%;
  max-width: 100%;
  min-height: ${({ $tall }) => ($tall ? '4.5rem' : '2rem')};
  border-radius: 4px;
`;
